export const positionLabels = {
  en: {
    'Accounting Staff / Accounting Officer': 'Accounting Staff / Accounting Officer',
    'Admin Manager': 'Admin Manager',
    'Assistant Manager / Operations Manager': 'Assistant Manager / Operations Manager',
    'Business Developer Manager': 'Business Developer Manager',
    'Content Moderator': 'Content Moderator',
    'Customer Service Representative': 'Customer Service Representative',
    'Data Labeler': 'Data Labeler',
    'Debt Collection Agent (Local)': 'Debt Collection Agent (Local)',
    'HR Specialist / HR Generalist': 'HR Specialist / HR Generalist',
    'IT Support': 'IT Support',
    'Operations Supervisor': 'Operations Supervisor',
    'Outbound Sales Agent': 'Outbound Sales Agent',
    'Project Manager': 'Project Manager',
    'QA Specialist / Analist': 'QA Specialist / Analist',
    'Recruiter': 'Recruiter',
    'Software Specialist': 'Software Specialist',
    'Team Leader': 'Team Leader',
    'Trainer': 'Trainer',
    'Executive Assistant / Executive Secretary': 'Executive Assistant / Executive Secretary',
    'Others': 'Others'
  },
  zh: {
    'Accounting Staff / Accounting Officer': '会计专员 / 会计主任',
    'Admin Manager': '行政经理',
    'Assistant Manager / Operations Manager': '助理经理 / 运营经理',
    'Business Developer Manager': '业务拓展经理',
    'Content Moderator': '内容审核员',
    'Customer Service Representative': '客户服务代表',
    'Data Labeler': '数据标注员',
    'Debt Collection Agent (Local)': '本地催收专员',
    'HR Specialist / HR Generalist': '人力资源专员',
    'IT Support': 'IT 技术支持',
    'Operations Supervisor': '运营主管',
    'Outbound Sales Agent': '外呼销售专员',
    'Project Manager': '项目经理',
    'QA Specialist / Analist': '质检专员 / 分析师',
    'Recruiter': '招聘专员',
    'Software Specialist': '软件专员',
    'Team Leader': '团队主管',
    'Trainer': '培训师',
    'Executive Assistant / Executive Secretary': '行政助理 / 执行秘书',
    'Others': '其他'
  }
};

export const positionDescriptionsI18n = {
  en: {
    'Accounting Staff / Accounting Officer': 'Handles bookkeeping, financial reporting, payroll coordination, and other accounting support tasks for Helport clients.',
    'Admin Manager': 'Oversees office operations, administrative processes, and ensures efficient support across departments.',
    'Assistant Manager / Operations Manager': 'Supports day-to-day operations, team coordination, and process improvement efforts.',
    'Business Developer Manager': 'Builds client relationships, identifies new business opportunities, and helps drive company growth.',
    'Content Moderator': 'Reviews online content, enforces quality standards, and ensures platform safety and compliance.',
    'Customer Service Representative': 'Handles customer inquiries, resolves issues, and delivers excellent client support via chat or phone.',
    'Data Labeler': 'Annotates and categorizes data for AI training, ensuring high-quality labeled datasets.',
    'Debt Collection Agent (Local)': 'Contacts customers to manage overdue accounts while maintaining professionalism and compliance.',
    'HR Specialist / HR Generalist': 'Supports recruitment, employee onboarding, policy implementation, and HR operations.',
    'IT Support': 'Provides technical assistance, troubleshooting, and system support for internal teams and clients.',
    'Operations Supervisor': 'Monitors team performance, ensures targets are met, and maintains operational quality.',
    'Outbound Sales Agent': 'Reaches out to prospects, promotes services, and closes sales opportunities over the phone.',
    'Project Manager': 'Plans, executes, and oversees projects to ensure timely delivery and client satisfaction.',
    'QA Specialist / Analist': 'Conducts quality assurance checks and analyzes process performance to improve outcomes.',
    'Recruiter': 'Sources candidates, conducts interviews, and helps place talent in the right roles.',
    'Software Specialist': 'Supports software applications, troubleshooting, and technical solutions for digital products.',
    'Team Leader': 'Guides and supports a team, monitors performance, and helps achieve project goals.',
    'Trainer': 'Delivers training sessions, skills coaching, and onboarding support for new hires.',
    'Executive Assistant / Executive Secretary': 'Provides high-level support, calendar management, and administrative assistance to executives.',
    'Others': 'Other specialized roles or flexible positions available across different departments.'
  },
  zh: {
    'Accounting Staff / Accounting Officer': '负责 Helport 客户的记账、财务报表、薪资协调及其他会计支持工作。',
    'Admin Manager': '负责办公室运营、行政流程，并确保各部门高效支持。',
    'Assistant Manager / Operations Manager': '支持日常运营、团队协调及流程改进。',
    'Business Developer Manager': '建立客户关系，发掘新业务机会，推动公司增长。',
    'Content Moderator': '审核在线内容，执行质量标准，确保平台安全与合规。',
    'Customer Service Representative': '处理客户咨询，解决问题，通过聊天或电话提供优质支持。',
    'Data Labeler': '为 AI 训练标注和分类数据，确保高质量标注数据集。',
    'Debt Collection Agent (Local)': '联系客户处理逾期账户，保持专业与合规。',
    'HR Specialist / HR Generalist': '支持招聘、员工入职、政策执行及人力资源运营。',
    'IT Support': '为内部团队及客户提供技术支持、故障排查与系统维护。',
    'Operations Supervisor': '监控团队绩效，确保达成目标并维持运营质量。',
    'Outbound Sales Agent': '主动联系潜在客户，推广服务并完成电话销售。',
    'Project Manager': '规划、执行并监督项目，确保按时交付与客户满意。',
    'QA Specialist / Analist': '进行质量检查并分析流程绩效以改进结果。',
    'Recruiter': '寻访候选人、组织面试并协助人才匹配合适岗位。',
    'Software Specialist': '支持软件应用、故障排查及数字产品技术方案。',
    'Team Leader': '指导和支持团队，监控绩效并协助达成项目目标。',
    'Trainer': '开展培训、技能辅导及新员工入职支持。',
    'Executive Assistant / Executive Secretary': '为高管提供高级支持、日程管理及行政协助。',
    'Others': '各部门其他专业或灵活岗位。'
  }
};

export const getPositionLabel = (lang, key) =>
  (positionLabels[lang] || positionLabels.zh)[key] || key;

export const getPositionDescription = (lang, key) =>
  (positionDescriptionsI18n[lang] || positionDescriptionsI18n.zh)[key] || '';
